import './Label.scss';

import React from 'react';
import PropTypes from 'prop-types';

export default class Label extends React.Component {
    static propTypes = {
        className: PropTypes.string,
        htmlFor: PropTypes.string,
        isWrappingLabel: PropTypes.bool
    };

    render() {
        let { className, isWrappingLabel, ...otherProps } = this.props;
        if(this.props.htmlFor != null || isWrappingLabel === true) {
            return (
                <label {...otherProps}
                       className={`c-label ${className || ''}`}>
                    {this.props.children}
                </label>
            );
        } else {
            return (
                <div className={`c-label ${className || ''}`}>
                    {this.props.children}
                </div>
            )
        }
    }
}



// WEBPACK FOOTER //
// ./src/components/Label/index.js